import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import * as ContactingApi from "../../../Requests/contactingAPIs";
import {
  CHUIProgressBackdrop,
  useCHUIDarkModeContext,
} from "@connecthealth-ui/core";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

export function AppointmentLanding(props) {
  const { push } = useHistory();
  const [apptInfo, setApptInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const { prefersDarkMode } = useCHUIDarkModeContext();

  //Get appt uid
  const value = queryString.parse(window.location.search);
  const appointmentUID = value.appointmentUID;

  //Controls how the date object is displayed
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const confirmAppointmentResult = await ContactingApi.manageAppointment(
          appointmentUID,
          "AppointmentInformation"
        );
        // Use this to change appt state for testing
        // confirmAppointmentResult.AppointmentBookingInformation.BookResendCancelConfirm =
        //   "Cancel";
        // confirmAppointmentResult.AppointmentBookingInformation.ClinicType =
        //   "Physioline";
        setApptInfo(confirmAppointmentResult.AppointmentBookingInformation);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
    // This is to prevent a warning of the deps array, deps array is empty to force it to run only once.
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    document.title = "Connect Health | Appointment";
  }, []);

  if (loading) {
    return <CHUIProgressBackdrop color="secondary" />;
  } else {
    return (
      <Fragment>
        <Box sx={{p: 5}}>
          <Typography
            variant="h4"
            sx={{
              textAlign: "center",
              padding: 3,
            }}
          >
            Hello, {apptInfo.FirstName}
          </Typography>
          <Container maxWidth="md">
            <Paper
              sx={{
                padding: 5,
              }}
              elevation={prefersDarkMode ? 2 : 1}
            >
              <List>
                <ListItem>
                  <Typography
                    variant="h5"
                    sx={{
                      color:
                        apptInfo.BookResendCancelConfirm === "Cancel"
                          ? "error.main"
                          : apptInfo.BookResendCancelConfirm === "Confirm"
                          ? "success.main"
                          : null,
                    }}
                  >
                    Appointment Details
                    {apptInfo.BookResendCancelConfirm === "Cancel" &&
                      " - Cancelled"}
                    {apptInfo.BookResendCancelConfirm === "Confirm" &&
                      " - Confirmed"}
                  </Typography>
                </ListItem>
                {apptInfo.BookResendCancelConfirm === "Cancel" && (
                  <Fragment>
                    <Divider />
                    <ListItem sx={{ pt: "1rem" }}>
                      <Typography>
                        Your appointment has been cancelled as requested. We
                        will contact you via telephone to rearrange your
                        appointment.
                      </Typography>
                    </ListItem>
                    <ListItem sx={{ pb: "1rem" }}>
                      <Typography>
                        If 7 days has passed and you have not received a
                        telephone call, get in touch with us through our{" "}
                        <Link
                          href="https://www.connecthealth.co.uk/contact/"
                          target="_blank"
                          rel="noopener"
                          color="inherit"
                          underline="always"
                        >
                          website
                        </Link>
                      </Typography>
                    </ListItem>
                  </Fragment>
                )}
                <Divider />
                <ListItem sx={{ padding: "1rem" }}>
                  <Typography>
                    Date:{" "}
                    {new Date(apptInfo.AppointmentDateTime).toLocaleDateString(
                      undefined,
                      options
                    ) +
                      " @ " +
                      new Date(apptInfo.AppointmentDateTime).toTimeString()}
                    {apptInfo.ClinicType === "Physioline" &&
                      " - You may be called 30 minutes either side of this appointment time, from a withheld number."}
                  </Typography>
                </ListItem>
                <ListItem sx={{ padding: "1rem" }}>
                  <Typography>Clinican: {apptInfo.Clinician}</Typography>
                </ListItem>
                <ListItem sx={{ padding: "1rem" }}>
                  <Typography>Type: {apptInfo.ClinicType}</Typography>
                </ListItem>
                {apptInfo.IsFaceToFaceAppointment && (
                  <ListItem sx={{ padding: "1rem" }}>
                    <Typography>Sitename: {apptInfo.SiteName}</Typography>
                  </ListItem>
                )}
                {apptInfo.IsTelephoneAppointment && (
                  <ListItem sx={{ padding: "1rem" }}>
                    <Typography>Telephone Appointment</Typography>
                  </ListItem>
                )}
                {apptInfo.IsVirtualAppointment && (
                  <ListItem sx={{ padding: "1rem" }}>
                    <Typography>Virtual Appointment</Typography>
                  </ListItem>
                )}
                <Divider />
                {apptInfo.BookResendCancelConfirm !== "Cancel" && (
                  <Stack
                    divider={<Divider orientation="vertical" flexItem />}
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={{ xs: 1, sm: 2, md: 4 }}
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Container>
                      <List>
                        <ListItem>
                          <CalendarTodayIcon />
                          <Typography sx={{ padding: "1rem" }}>
                            <Link
                              href={`https://calendar.google.com/calendar/r/eventedit?text=Connect%20Health%20Appointment&details=${
                                apptInfo.ClinicType
                              }%20with%20${apptInfo.Clinician}&dates=${new Date(
                                apptInfo.AppointmentDateTime
                              )
                                .toISOString()
                                .replace(/-|:|\.\d\d\d/g, "")}/${new Date(
                                apptInfo.AppointmentDateTime
                              )
                                .toISOString()
                                .replace(/-|:|\.\d\d\d/g, "")}`}
                              target="_blank"
                              rel="noopener"
                              color="inherit"
                              underline="always"
                            >
                              Add to Google Calendar
                            </Link>
                          </Typography>
                        </ListItem>
                      </List>
                    </Container>

                    <Container>
                      <List>
                        <ListItem>
                          <CalendarTodayIcon />
                          <Typography sx={{ padding: "1rem" }}>
                            <Link
                              href={`https://outlook.office.com/calendar/0/deeplink/compose?body=${
                                apptInfo.ClinicType
                              }%20with%20${apptInfo.Clinician}&enddt=${new Date(
                                apptInfo.AppointmentDateTime
                              ).toISOString()}&location=${
                                apptInfo.SiteName
                              }&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${new Date(
                                apptInfo.AppointmentDateTime
                              ).toISOString()}&subject=Connect%20Health%20Appointment`}
                              target="_blank"
                              rel="noopener"
                              color="inherit"
                              underline="always"
                            >
                              Add to Outlook Calendar
                            </Link>
                          </Typography>
                        </ListItem>
                      </List>
                    </Container>
                  </Stack>
                )}
                {apptInfo.BookResendCancelConfirm !== "Cancel" && (
                  <Fragment>
                    <Divider />
                    <ListItem sx={{ paddingTop: "1rem" }}>
                      <Typography>
                        You will also find lots of information on our{" "}
                        <Link
                          href="https://www.connecthealth.co.uk/contact/"
                          target="_blank"
                          rel="noopener"
                          color="inherit"
                          underline="always"
                        >
                          website
                        </Link>{" "}
                        about your service, including opening times, services
                        offered, a map for directions and who your clinicians
                        are.
                      </Typography>
                    </ListItem>
                  </Fragment>
                )}
              </List>
            </Paper>

            <Grid
              container
              spacing={3}
              sx={{
                marginTop: 5,
              }}
            >
              <Grid item xs>
                <Button
                  disabled={
                    (apptInfo.BookResendCancelConfirm === "Cancel" && true) ||
                    (apptInfo.BookResendCancelConfirm === "Confirm" && true) ||
                    (apptInfo.BookResendCancelConfirm === "Book" && false)
                  }
                  variant="contained"
                  color="primary"
                  sx={{
                    width: "100%",
                  }}
                  onClick={() =>
                    push(
                      `/Appointments/AppointmentBooking/ConfirmAppointment?appointmentUID=${appointmentUID}`
                    )
                  }
                >
                  Confirm Appointment
                </Button>
              </Grid>
              <Grid item xs>
                <Button
                  disabled={
                    (apptInfo.BookResendCancelConfirm === "Cancel" && true) ||
                    (apptInfo.BookResendCancelConfirm === "Confirm" && false) ||
                    (apptInfo.BookResendCancelConfirm === "Book" && false)
                  }
                  variant="contained"
                  color="secondary"
                  sx={{
                    width: "100%",
                  }}
                  onClick={() =>
                    push(
                      `/Appointments/AppointmentBooking/CancelAppointment?appointmentUID=${appointmentUID}`
                    )
                  }
                >
                  Cancel Appointment
                </Button>
              </Grid>
            </Grid>
          </Container> 
        </Box>
      </Fragment>
    );
  }
}
